
import en from './EN.js'
export default { en }